/**
 * API: Reporte de Carga Académica
 * Endpoint backend: GET /escolar/reportes/carga-academica/
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function getHeaders() {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

/**
 * Obtiene el reporte de carga académica.
 *
 * @param {Object} params
 * @param {'ASESOR'|'ESTUDIANTE'} params.tipo_reporte - REQUERIDO
 * @param {number|string} params.id_ciclo_escolar     - REQUERIDO
 * @param {number|string} [params.id_campus]
 * @param {number|string} [params.id_seccion]
 * @param {number|string} [params.id_asesor]      // tipo=ASESOR
 * @param {number|string} [params.id_estudiante]  // tipo=ESTUDIANTE
 * @param {string}        [params.matricula]      // tipo=ESTUDIANTE
 * @returns {Promise<{tipo_reporte:string,total:number,resultados:Array}>}
 */
export async function getReporteCargaAcademica({
  tipo_reporte,
  id_ciclo_escolar,
  id_campus,
  id_seccion,
  id_asesor,
  id_estudiante,
  matricula,
} = {}) {
  if (!tipo_reporte) {
    throw new Error("Parámetro 'tipo_reporte' es requerido (ASESOR | ESTUDIANTE).");
  }
  if (!id_ciclo_escolar) {
    throw new Error("Parámetro 'id_ciclo_escolar' es requerido.");
  }

  const qs = new URLSearchParams();
  qs.set('tipo_reporte', String(tipo_reporte).toUpperCase());
  qs.set('id_ciclo_escolar', String(id_ciclo_escolar));

  const optional = { id_campus, id_seccion, id_asesor, id_estudiante };
  Object.entries(optional).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '' && v !== 'todos') {
      qs.set(k, String(v));
    }
  });
  if (matricula && String(matricula).trim() !== '') {
    qs.set('matricula', String(matricula).trim());
  }
  qs.set('_t', String(Date.now()));

  const url = `${API_BASE}/escolar/reportes/carga-academica/?${qs.toString()}`;
  const res = await fetch(url, { headers: getHeaders(), cache: 'no-store' });

  if (!res.ok) {
    let errorMsg = `Error ${res.status} al obtener el reporte`;
    try {
      const errorData = await res.json();
      errorMsg = errorData.error || errorMsg;
    } catch (_) { /* ignore */ }
    throw new Error(errorMsg);
  }

  return await res.json();
}

export default getReporteCargaAcademica;
